export default "__VITE_ASSET__f6d58a9f__"